namespace RioERP.Masters {
    export interface WhatsAppGatewaySettingsForm {
        ApiKey: Serenity.StringEditor;
        ApiUrl: Serenity.StringEditor;
        Sender: Serenity.StringEditor;
        IsActive: Serenity.IntegerEditor;
    }

    export class WhatsAppGatewaySettingsForm extends Serenity.PrefixedContext {
        static formKey = 'Masters.WhatsAppGatewaySettings';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!WhatsAppGatewaySettingsForm.init)  {
                WhatsAppGatewaySettingsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;

                Q.initFormType(WhatsAppGatewaySettingsForm, [
                    'ApiKey', w0,
                    'ApiUrl', w0,
                    'Sender', w0,
                    'IsActive', w1
                ]);
            }
        }
    }
}
